import React from 'react';
import { Modal, ModalHeader, ModalBody, Row, Col } from 'reactstrap';
import { displayValue } from '../QuantityTable';

const RestrictionCard = ({ title, unit, min, max }) => (
  <div className='bg-light rounded p-3 h-100'>
    <div className='text-muted fw-semibold fs-13 mb-3'>{title}</div>

    <div className='bg-white border rounded p-2 mb-2 d-flex justify-content-between align-items-center px-3'>
      <span className='text-muted fs-13' style={{ width: '30%' }}>
        Min
      </span>
      <span
        className='text-dark fw-medium fs-13 text-center'
        style={{ width: '40%' }}
      >
        {displayValue(min)}
      </span>
      <span className='text-muted fs-13 text-end' style={{ width: '30%' }}>
        {unit}
      </span>
    </div>

    <div className='bg-white border rounded p-2 d-flex justify-content-between align-items-center px-3'>
      <span className='text-muted fs-13' style={{ width: '30%' }}>
        Max
      </span>
      <span
        className='text-dark fw-medium fs-13 text-center'
        style={{ width: '40%' }}
      >
        {displayValue(max)}
      </span>
      <span className='text-muted fs-13 text-end' style={{ width: '30%' }}>
        {unit}
      </span>
    </div>
  </div>
);

const PortRestrictionModal = ({ isOpen, toggle, data }) => {
  const portName = data?.name || data?.portName;

  return (
    <Modal isOpen={isOpen} toggle={toggle} size='lg' centered>
      <ModalHeader toggle={toggle} className='border-bottom'>
        <span className='fw-bold text-dark fs-16'>Port Restriction</span>
      </ModalHeader>

      <ModalBody className='p-4'>
        <div className='border-start border-2 border-primary ps-3 mb-4'>
          <div className='text-muted fw-semibold mb-1 fs-13'>Port Name</div>
          <div className='text-dark fw-medium fs-14'>
            {displayValue(portName)}
          </div>
        </div>

        <Row className='g-3'>
          <Col md={4}>
            <RestrictionCard
              title='Draft(m)'
              unit='m'
              min={data?.draftMin}
              max={data?.draftMax}
            />
          </Col>
          <Col md={4}>
            <RestrictionCard
              title='LOA(m)'
              unit='m'
              min={data?.loaMin}
              max={data?.loaMax}
            />
          </Col>
          <Col md={4}>
            <RestrictionCard
              title='DWT(MT)'
              unit='MT'
              min={data?.dwtMin}
              max={data?.dwtMax}
            />
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  );
};

export default PortRestrictionModal;
